<template>
  <v-container>
    <h1 class="mt-6 mb-12 text-h4 text-sm-h3 header-font">Site map</h1>
    <div class="mb-6" v-for="link in links" :key="link.route">
      <h2 class="title"><router-link :to="link.route">{{link.route}}</router-link></h2>
      <div>{{link.details}}</div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'site-map',

  routerViewMeta: {
    title: 'Ellacard site map'
  },

  data() {
    return {
      links: [
        { route: '/start', details: 'Getting started with Ellacard' },
        { route: '/start/group-cards', details: 'Learn about our group cards' },
        { route: '/start/invitations', details: 'Learn about our invitations' },
        { route: '/start/gift-cards', details: 'Learn about our gift cards' },
        { route: '/start/holidays', details: 'Learn about our holiday offerings' },
        { route: '/start/video-maker', details: 'Learn about our video maker' },
        { route: '/start/recognition', details: 'Learn how to use Ellacard for employee recognition / rewards' },
        { route: '/start/automation', details: 'Learn about our automation tools for sending cards' },
        { route: '/start/bulk-email', details: 'Learn about our bulk email tool' },
        { route: '/start/embedding-api', details: 'Learn about our embedding-api' },
        { route: '/start/business', details: 'Learn about our business / organization products' },
        { route: '/design', details: 'Learn about our external design program' },
        { route: '/categories', details: 'Browse / search our list of greeting card and invitation categories' },
        { route: '/cards', details: 'Browse / search our catalog of group card designs' },
        { route: '/gift-cards', details: 'Browse / search our catalog of gift cards' },
        { route: '/videos', details: 'Browse / search our catalog of group video themes' },
        { route: '/account', details: "Manage cards / videos that you've sent, signed, and received" },
        { route: '/featured', details: 'Specific cards that we especially like' },
        { route: '/img-to-design', details: 'Create a reusable card design with an image' },
        { route: '/batch-order', details: 'Order / schedule multiple cards at once by uploading a spreadsheet' },
        { route: '/file-transfer', details: 'Securely store files / transfer to Ellacard' },
        { route: '/faq', details: 'Frequently asked questions' },
        { route: '/international-gift-cards', details: 'A list of all gift cards carried by Ellacard (by country)' },
        { route: '/about', details: 'About the company' },
        { route: '/blog', details: "Learn more about our products, company, and the challenges we've overcome" },
        { route: '/social', details: 'Find us on social media' },
        { route: '/api-docs', details: 'Ellacard API documentation' },
        { route: '/video-template-docs', details: 'Ellacard video template documentation' },
        { route: '/cookies', details: 'Learn about how we use cookies and manage your preferences' },
        { route: '/privacy-policy', details: 'Privacy policy' },
        { route: '/terms-and-conditions', details: 'Terms and conditions' }
      ]
    };
  }
}
</script>
